import {getProduct} from '../services';
import axios from 'axios';

//格式化商品
function formatGoods(deliver) {

  return deliver && deliver.goods && deliver.goods.map((data) => { 

    //合并扩展字段
    data.exts = Object.assign({}, deliver.exts, data.exts);

    // 设置优惠id
    data.activityId = data.exts.activityId && data.exts.activityId.value || deliver.promotionId;
    
    data.product = getProduct(data);
    
    return data;
  });
}

//获取投放池商品
function getGoodsByDeliver(deliverId) {
  return new Promise((resolve) => {
    axios({
      method: 'get',
      url: 'https://query.aliyun.com/rest/content-platform.deliveryContent?id=' + deliverId,
    }).then((res) => {
      if (res && res.data.code == '200' && res.data.code == '200'){
        resolve(formatGoods(res.data.data));
      }
      else {
        resolve();
      }
    });
  }).catch((err) => {
    console.error(err);
  });
}

export {getGoodsByDeliver, formatGoods};


// WEBPACK FOOTER //
// ./lib/goods/index.js